import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeSideNavID: "viewRedeemableSerial",
};

export const loyaltySideNavSlice = createSlice({
  name: "loyaltySideNav",
  initialState,
  reducers: {
    setActiveSideNavID: (state, { payload }) => {
      state.activeSideNavID = payload;
    },
  },
});

export const { setActiveSideNavID } = loyaltySideNavSlice.actions;

export default loyaltySideNavSlice.reducer;
